/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { AxiosPromise } from 'axios'
import {
  AiTranslateResponse,
  BatchAiTranslateParams,
  AiDvsResponse,
  SpeechSynthesisParams,
  VoiceListModel,
  AiTaskModel,
  ResultModel,
  AiDvsSplitParams,
  AiDvsSplitResponse,
  VoiceParams,
} from '@/api/ai/index.type'
import { ResponseData } from 'request'

export function batchAiTranslate(
  data: BatchAiTranslateParams,
): AxiosPromise<ResponseData<AiTranslateResponse>> {
  return request({
    url: v2Host + '/ai/translate',
    method: 'post',
    data,
  })
}

// 语音合成-语言列表
export const getVoiceLanguage = () =>
  request.get<ResponseData<string[] | null>>(v2Host + '/ai/tts-voice-language')

// 语音合成-音色列表
export const getVoiceList = (params: VoiceParams) =>
  request.get<ResponseData<{ list: VoiceListModel[] | null }>>(
    v2Host + '/ai/tts-voice',
    {
      params,
    },
  )

// 语音合成
export const speechSynthesisSuccess = (data: SpeechSynthesisParams) =>
  request.post<ResponseData<{ ids: number[] | null }>>(
    v2Host + '/ai/tts',
    data,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )

// 异步任务查询
export const getAiTask = <T = ResultModel>(params: { ids: string }) =>
  request.get<ResponseData<AiTaskModel<T>[] | null>>(v2Host + '/async/query', {
    params,
  })

// 镜头识别
export function aiDvs(data: {
  source: string
  video_url: string
}): AxiosPromise<ResponseData<AiDvsResponse>> {
  return request({
    url: v2Host + '/ai/dvs',
    method: 'post',
    data,
  })
}

// 视频切片
export function aiDvsSplit(
  data: AiDvsSplitParams,
): AxiosPromise<ResponseData<AiDvsSplitResponse>> {
  return request({
    url: v2Host + '/ai/dvs-split',
    method: 'post',
    data,
  })
}
